import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BackendService } from './backend.service';
import { QueryOptions, QueryResult } from '../components/common-dto/query.dto';
import { VendorDto } from '../dto/vendor.dto';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  constructor(
    private backend: BackendService,
    private http: HttpClient
  ) {}

  getVendors(
    conferenceId: string,
    queryParams: QueryOptions
  ): Observable<QueryResult<VendorDto>> {
    return this.backend.getQuery<VendorDto>(
      `conference/${conferenceId}/vendors`,
      queryParams
    );
  }
}

